"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: referral/referral.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Freferral%2Freferral.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.inviteSentMethodToJSON = exports.inviteSentMethodFromJSON = exports.referralErrorCodeToJSON = exports.referralErrorCodeFromJSON = exports.RedeemerReward = exports.RewardedReferral = exports.ReferralInvite = exports.InviteSentMethod = exports.ReferralErrorCode = void 0;
const alias_1 = require("../common/alias");
const amount_1 = require("../common/amount");
const referral_invite_status_1 = require("../common/referral-invite-status");
const protobufPackage = 'com.step.referral.proto';
var ReferralErrorCode;
(function (ReferralErrorCode) {
    ReferralErrorCode["FAILED_TO_ISSUE_REWARD"] = "FAILED_TO_ISSUE_REWARD";
    ReferralErrorCode["SELF_REFERRAL_DISALLOWED"] = "SELF_REFERRAL_DISALLOWED";
    ReferralErrorCode["INVALID_REFERRAL"] = "INVALID_REFERRAL";
    ReferralErrorCode["ALREADY_REFERRED"] = "ALREADY_REFERRED";
    ReferralErrorCode["REFERRAL_CODES_DEPLETED"] = "REFERRAL_CODES_DEPLETED";
    ReferralErrorCode["ALREADY_REDEEMED_CODE"] = "ALREADY_REDEEMED_CODE";
    ReferralErrorCode["REFERRER_SUSPENDED"] = "REFERRER_SUSPENDED";
    ReferralErrorCode["REWARD_WINDOW_EXPIRED"] = "REWARD_WINDOW_EXPIRED";
    ReferralErrorCode["NOT_ONBOARDED"] = "NOT_ONBOARDED";
    ReferralErrorCode["NOT_KYCED_OR_SPONSORED"] = "NOT_KYCED_OR_SPONSORED";
    ReferralErrorCode["VOIP_REDEMPTION_UNSUPPORTED"] = "VOIP_REDEMPTION_UNSUPPORTED";
    /**
     * DEVICE_QUOTA_EXCEEDED - The same device is used to redeem 2 or more codes.
     */
    ReferralErrorCode["DEVICE_QUOTA_EXCEEDED"] = "DEVICE_QUOTA_EXCEEDED";
    ReferralErrorCode["REDEEMER_INACTIVE"] = "REDEEMER_INACTIVE";
    ReferralErrorCode["CAMPAIGN_EXPIRED"] = "CAMPAIGN_EXPIRED";
    ReferralErrorCode["UNDER_13_REDEMPTION_UNSUPPORTED"] = "UNDER_13_REDEMPTION_UNSUPPORTED";
    ReferralErrorCode["DISPOSABLE_EMAIL_REDEMPTION"] = "DISPOSABLE_EMAIL_REDEMPTION";
    /**
     * GENERIC_REDEMPTION_UNSUPPORTED - Generic catch all for failed redemptions due to suspicious activity.
     */
    ReferralErrorCode["GENERIC_REDEMPTION_UNSUPPORTED"] = "GENERIC_REDEMPTION_UNSUPPORTED";
    ReferralErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ReferralErrorCode || (exports.ReferralErrorCode = ReferralErrorCode = {}));
var InviteSentMethod;
(function (InviteSentMethod) {
    InviteSentMethod["INVALID_INVITE_TYPE"] = "INVALID_INVITE_TYPE";
    InviteSentMethod["CLIENT_SENT_INVITE"] = "CLIENT_SENT_INVITE";
    InviteSentMethod["SERVER_SENT_INVITE"] = "SERVER_SENT_INVITE";
    InviteSentMethod["UNRECOGNIZED"] = "UNRECOGNIZED";
})(InviteSentMethod || (exports.InviteSentMethod = InviteSentMethod = {}));
function createBaseReferralInvite() {
    return {
        referrerUserId: '',
        redeemerUserId: '',
        aliases: [],
        status: referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS,
        errorCode: ReferralErrorCode.FAILED_TO_ISSUE_REWARD,
        redeemerReward: undefined,
        rewardedReferral: undefined,
        invitedAtMs: '0',
        startedRedemptionAtMs: '0',
        expiresAtMs: '0',
    };
}
exports.ReferralInvite = {
    fromJSON(object) {
        const message = {
            referrerUserId: isSet(object.referrerUserId) ? globalThis.String(object.referrerUserId) : '',
            status: isSet(object.status)
                ? (0, referral_invite_status_1.referralInviteStatusFromJSON)(object.status)
                : referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS,
        };
        if (isSet(object.redeemerUserId)) {
            message.redeemerUserId = globalThis.String(object.redeemerUserId);
        }
        if (globalThis.Array.isArray(object?.aliases)) {
            message.aliases = object.aliases.map((e) => alias_1.Alias.fromJSON(e));
        }
        if (isSet(object.errorCode)) {
            message.errorCode = referralErrorCodeFromJSON(object.errorCode);
        }
        if (isSet(object.redeemerReward)) {
            message.redeemerReward = exports.RedeemerReward.fromJSON(object.redeemerReward);
        }
        if (isSet(object.rewardedReferral)) {
            message.rewardedReferral = exports.RewardedReferral.fromJSON(object.rewardedReferral);
        }
        if (isSet(object.invitedAtMs)) {
            message.invitedAtMs = globalThis.String(object.invitedAtMs);
        }
        if (isSet(object.startedRedemptionAtMs)) {
            message.startedRedemptionAtMs = globalThis.String(object.startedRedemptionAtMs);
        }
        if (isSet(object.expiresAtMs)) {
            message.expiresAtMs = globalThis.String(object.expiresAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referrerUserId !== '') {
            obj.referrerUserId = message.referrerUserId;
        }
        if (message.redeemerUserId !== undefined && message.redeemerUserId !== '') {
            obj.redeemerUserId = message.redeemerUserId;
        }
        if (message.aliases?.length) {
            obj.aliases = message.aliases.map((e) => alias_1.Alias.toJSON(e));
        }
        if (message.status !== referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS) {
            obj.status = (0, referral_invite_status_1.referralInviteStatusToJSON)(message.status);
        }
        if (message.errorCode !== undefined &&
            message.errorCode !== ReferralErrorCode.FAILED_TO_ISSUE_REWARD) {
            obj.errorCode = referralErrorCodeToJSON(message.errorCode);
        }
        if (message.redeemerReward !== undefined) {
            obj.redeemerReward = exports.RedeemerReward.toJSON(message.redeemerReward);
        }
        if (message.rewardedReferral !== undefined) {
            obj.rewardedReferral = exports.RewardedReferral.toJSON(message.rewardedReferral);
        }
        if (message.invitedAtMs !== undefined && message.invitedAtMs !== '0') {
            obj.invitedAtMs = message.invitedAtMs;
        }
        if (message.startedRedemptionAtMs !== undefined && message.startedRedemptionAtMs !== '0') {
            obj.startedRedemptionAtMs = message.startedRedemptionAtMs;
        }
        if (message.expiresAtMs !== undefined && message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.ReferralInvite.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferralInvite();
        message.referrerUserId = object.referrerUserId ?? '';
        message.redeemerUserId = object.redeemerUserId ?? '';
        message.aliases = object.aliases?.map((e) => alias_1.Alias.fromPartial(e)) || [];
        message.status = object.status ?? referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS;
        message.errorCode = object.errorCode ?? ReferralErrorCode.FAILED_TO_ISSUE_REWARD;
        message.redeemerReward = (object.redeemerReward !== undefined && object.redeemerReward !== null)
            ? exports.RedeemerReward.fromPartial(object.redeemerReward)
            : undefined;
        message.rewardedReferral =
            (object.rewardedReferral !== undefined && object.rewardedReferral !== null)
                ? exports.RewardedReferral.fromPartial(object.rewardedReferral)
                : undefined;
        message.invitedAtMs = object.invitedAtMs ?? '0';
        message.startedRedemptionAtMs = object.startedRedemptionAtMs ?? '0';
        message.expiresAtMs = object.expiresAtMs ?? '0';
        return message;
    },
};
function createBaseRewardedReferral() {
    return {
        redeemerFirstName: '',
        redeemerFullName: '',
        redeemerPictureUrl: '',
        redeemerRewardedAtMs: '0',
        campaign: '',
        referrerRewardedAmount: undefined,
        referrerRewardedAtMs: '0',
    };
}
exports.RewardedReferral = {
    fromJSON(object) {
        const message = {
            redeemerFirstName: isSet(object.redeemerFirstName)
                ? globalThis.String(object.redeemerFirstName)
                : '',
            redeemerFullName: isSet(object.redeemerFullName)
                ? globalThis.String(object.redeemerFullName)
                : '',
            redeemerRewardedAtMs: isSet(object.redeemerRewardedAtMs)
                ? globalThis.String(object.redeemerRewardedAtMs)
                : '0',
            campaign: isSet(object.campaign) ? globalThis.String(object.campaign) : '',
        };
        if (isSet(object.redeemerPictureUrl)) {
            message.redeemerPictureUrl = globalThis.String(object.redeemerPictureUrl);
        }
        if (isSet(object.referrerRewardedAmount)) {
            message.referrerRewardedAmount = amount_1.Amount.fromJSON(object.referrerRewardedAmount);
        }
        if (isSet(object.referrerRewardedAtMs)) {
            message.referrerRewardedAtMs = globalThis.String(object.referrerRewardedAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.redeemerFirstName !== '') {
            obj.redeemerFirstName = message.redeemerFirstName;
        }
        if (message.redeemerFullName !== '') {
            obj.redeemerFullName = message.redeemerFullName;
        }
        if (message.redeemerPictureUrl !== undefined && message.redeemerPictureUrl !== '') {
            obj.redeemerPictureUrl = message.redeemerPictureUrl;
        }
        if (message.redeemerRewardedAtMs !== '0') {
            obj.redeemerRewardedAtMs = message.redeemerRewardedAtMs;
        }
        if (message.campaign !== '') {
            obj.campaign = message.campaign;
        }
        if (message.referrerRewardedAmount !== undefined) {
            obj.referrerRewardedAmount = amount_1.Amount.toJSON(message.referrerRewardedAmount);
        }
        if (message.referrerRewardedAtMs !== undefined && message.referrerRewardedAtMs !== '0') {
            obj.referrerRewardedAtMs = message.referrerRewardedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.RewardedReferral.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRewardedReferral();
        message.redeemerFirstName = object.redeemerFirstName ?? '';
        message.redeemerFullName = object.redeemerFullName ?? '';
        message.redeemerPictureUrl = object.redeemerPictureUrl ?? '';
        message.redeemerRewardedAtMs = object.redeemerRewardedAtMs ?? '0';
        message.campaign = object.campaign ?? '';
        message.referrerRewardedAmount =
            (object.referrerRewardedAmount !== undefined && object.referrerRewardedAmount !== null)
                ? amount_1.Amount.fromPartial(object.referrerRewardedAmount)
                : undefined;
        message.referrerRewardedAtMs = object.referrerRewardedAtMs ?? '0';
        return message;
    },
};
function createBaseRedeemerReward() {
    return { campaign: '', amount: amount_1.Amount.fromPartial({}) };
}
exports.RedeemerReward = {
    fromJSON(object) {
        const message = {
            campaign: isSet(object.campaign) ? globalThis.String(object.campaign) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.campaign !== '') {
            obj.campaign = message.campaign;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.RedeemerReward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRedeemerReward();
        message.campaign = object.campaign ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function referralErrorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'FAILED_TO_ISSUE_REWARD':
            return ReferralErrorCode.FAILED_TO_ISSUE_REWARD;
        case 1:
        case 'SELF_REFERRAL_DISALLOWED':
            return ReferralErrorCode.SELF_REFERRAL_DISALLOWED;
        case 2:
        case 'INVALID_REFERRAL':
            return ReferralErrorCode.INVALID_REFERRAL;
        case 3:
        case 'ALREADY_REFERRED':
            return ReferralErrorCode.ALREADY_REFERRED;
        case 4:
        case 'REFERRAL_CODES_DEPLETED':
            return ReferralErrorCode.REFERRAL_CODES_DEPLETED;
        case 5:
        case 'ALREADY_REDEEMED_CODE':
            return ReferralErrorCode.ALREADY_REDEEMED_CODE;
        case 6:
        case 'REFERRER_SUSPENDED':
            return ReferralErrorCode.REFERRER_SUSPENDED;
        case 7:
        case 'REWARD_WINDOW_EXPIRED':
            return ReferralErrorCode.REWARD_WINDOW_EXPIRED;
        case 8:
        case 'NOT_ONBOARDED':
            return ReferralErrorCode.NOT_ONBOARDED;
        case 9:
        case 'NOT_KYCED_OR_SPONSORED':
            return ReferralErrorCode.NOT_KYCED_OR_SPONSORED;
        case 10:
        case 'VOIP_REDEMPTION_UNSUPPORTED':
            return ReferralErrorCode.VOIP_REDEMPTION_UNSUPPORTED;
        case 11:
        case 'DEVICE_QUOTA_EXCEEDED':
            return ReferralErrorCode.DEVICE_QUOTA_EXCEEDED;
        case 12:
        case 'REDEEMER_INACTIVE':
            return ReferralErrorCode.REDEEMER_INACTIVE;
        case 13:
        case 'CAMPAIGN_EXPIRED':
            return ReferralErrorCode.CAMPAIGN_EXPIRED;
        case 14:
        case 'UNDER_13_REDEMPTION_UNSUPPORTED':
            return ReferralErrorCode.UNDER_13_REDEMPTION_UNSUPPORTED;
        case 15:
        case 'DISPOSABLE_EMAIL_REDEMPTION':
            return ReferralErrorCode.DISPOSABLE_EMAIL_REDEMPTION;
        case 16:
        case 'GENERIC_REDEMPTION_UNSUPPORTED':
            return ReferralErrorCode.GENERIC_REDEMPTION_UNSUPPORTED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ReferralErrorCode.UNRECOGNIZED;
    }
}
exports.referralErrorCodeFromJSON = referralErrorCodeFromJSON;
function referralErrorCodeToJSON(object) {
    switch (object) {
        case ReferralErrorCode.FAILED_TO_ISSUE_REWARD:
            return 'FAILED_TO_ISSUE_REWARD';
        case ReferralErrorCode.SELF_REFERRAL_DISALLOWED:
            return 'SELF_REFERRAL_DISALLOWED';
        case ReferralErrorCode.INVALID_REFERRAL:
            return 'INVALID_REFERRAL';
        case ReferralErrorCode.ALREADY_REFERRED:
            return 'ALREADY_REFERRED';
        case ReferralErrorCode.REFERRAL_CODES_DEPLETED:
            return 'REFERRAL_CODES_DEPLETED';
        case ReferralErrorCode.ALREADY_REDEEMED_CODE:
            return 'ALREADY_REDEEMED_CODE';
        case ReferralErrorCode.REFERRER_SUSPENDED:
            return 'REFERRER_SUSPENDED';
        case ReferralErrorCode.REWARD_WINDOW_EXPIRED:
            return 'REWARD_WINDOW_EXPIRED';
        case ReferralErrorCode.NOT_ONBOARDED:
            return 'NOT_ONBOARDED';
        case ReferralErrorCode.NOT_KYCED_OR_SPONSORED:
            return 'NOT_KYCED_OR_SPONSORED';
        case ReferralErrorCode.VOIP_REDEMPTION_UNSUPPORTED:
            return 'VOIP_REDEMPTION_UNSUPPORTED';
        case ReferralErrorCode.DEVICE_QUOTA_EXCEEDED:
            return 'DEVICE_QUOTA_EXCEEDED';
        case ReferralErrorCode.REDEEMER_INACTIVE:
            return 'REDEEMER_INACTIVE';
        case ReferralErrorCode.CAMPAIGN_EXPIRED:
            return 'CAMPAIGN_EXPIRED';
        case ReferralErrorCode.UNDER_13_REDEMPTION_UNSUPPORTED:
            return 'UNDER_13_REDEMPTION_UNSUPPORTED';
        case ReferralErrorCode.DISPOSABLE_EMAIL_REDEMPTION:
            return 'DISPOSABLE_EMAIL_REDEMPTION';
        case ReferralErrorCode.GENERIC_REDEMPTION_UNSUPPORTED:
            return 'GENERIC_REDEMPTION_UNSUPPORTED';
        case ReferralErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.referralErrorCodeToJSON = referralErrorCodeToJSON;
function inviteSentMethodFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_INVITE_TYPE':
            return InviteSentMethod.INVALID_INVITE_TYPE;
        case 1:
        case 'CLIENT_SENT_INVITE':
            return InviteSentMethod.CLIENT_SENT_INVITE;
        case 2:
        case 'SERVER_SENT_INVITE':
            return InviteSentMethod.SERVER_SENT_INVITE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return InviteSentMethod.UNRECOGNIZED;
    }
}
exports.inviteSentMethodFromJSON = inviteSentMethodFromJSON;
function inviteSentMethodToJSON(object) {
    switch (object) {
        case InviteSentMethod.INVALID_INVITE_TYPE:
            return 'INVALID_INVITE_TYPE';
        case InviteSentMethod.CLIENT_SENT_INVITE:
            return 'CLIENT_SENT_INVITE';
        case InviteSentMethod.SERVER_SENT_INVITE:
            return 'SERVER_SENT_INVITE';
        case InviteSentMethod.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.inviteSentMethodToJSON = inviteSentMethodToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=referral.js.map